module.exports = __webpack_public_path__ + "img/ready-to-scan-2_transparent.4bc3d186.png";